import {
  Archive,
  BoxIso,
  Calendar,
  MediaImage,
  PageEdit,
  Star,
  ViewGrid,
  WarningTriangle,
  MediaImagePlus,
  Flash,
} from "iconoir-react";
import { type IAppViewSection } from "shared/components";

export enum WidgetKey {
  All = "ALL",
  Archived = "ARCHIVED",
  Event = "EVENT",
  Inquiry = "INQUIRY",
  /** Parent: Gallery Widgets list; Needs Attention / New Media nest underneath */
  Gallery = "GALLERY",
  NeedsAttention = "NEEDS_ATTENTION",
  NewMedia = "NEW_MEDIA",
  Promotion = "PROMOTION",
  Favorited = "FAVORITED",
  Operator = "OPERATOR",
  /** Widget Settings moved to Organization Settings (App Settings > Widget Settings) */
  Settings = "SETTINGS",
}

export const widgetViewSections: IAppViewSection[] = [
  {
    items: [
      {
        Icon: BoxIso,
        key: WidgetKey.All,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: ViewGrid,
        key: WidgetKey.Operator,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: Calendar,
        key: WidgetKey.Event,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: PageEdit,
        key: WidgetKey.Inquiry,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: MediaImage,
        key: WidgetKey.Gallery,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: WarningTriangle,
        key: WidgetKey.NeedsAttention,
        text: "",
        count: 0,
        isSelected: false,
        indent: 1,
      },
      {
        Icon: MediaImagePlus,
        key: WidgetKey.NewMedia,
        text: "",
        count: 0,
        isSelected: false,
        indent: 1,
      },
      {
        Icon: Flash,
        key: WidgetKey.Promotion,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: Star,
        key: WidgetKey.Favorited,
        text: "",
        count: 0,
        isSelected: false,
      },
    ],
  },
  {
    items: [
      {
        Icon: Archive,
        key: WidgetKey.Archived,
        text: "",
        count: 0,
        isSelected: false,
      },
    ],
  },
];
